// React import removed
import { Routes, Route } from 'react-router-dom'
import AdminLayout from './AdminLayout'
import AdminOverview from './AdminOverview'
import ChurchManagement from './ChurchManagement'
import UserManagement from './UserManagement'
import UserApproval from './UserApproval'
import CompetitionManagement from './CompetitionManagement'
import TournamentManagement from './TournamentManagement'
import TournamentBracket from './TournamentBracket'

const AdminDashboard: React.FC = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<AdminOverview />} />
        <Route path="churches" element={<ChurchManagement />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="user-approval" element={<UserApproval />} />
        <Route path="competitions" element={<CompetitionManagement />} />
        <Route path="tournaments" element={<TournamentManagement />} />
        <Route path="tournaments/:tournamentId/bracket" element={<TournamentBracket />} />
      </Routes>
    </AdminLayout>
  )
}

export default AdminDashboard